import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation, Trans } from "react-i18next";
import InsButton from "../../../../components/InsButton/InsButton";
import InsInput from "../../../../components/InsInput/InsInput";
import Validate from "../../../../ressources/validation";
import ValidatePassword from "../../../../components/ValidatePassword/ValidatePassword";
import StepCount from "../../../../components/StepCount/StepCount";
import "./Step3.scss";
import { connect } from "react-redux";
import ConnectOptin from "components/ConnectOptin/ConnectOptin";

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordConfirm: "",
      passwordConfirmError: "",
      captcha: "bypassed",
      optins: [],
      fields: [],
      newsletter: false,
      validConsent: false
    };
  }
  static propTypes = {
    onValidate: PropTypes.func,
  };

  componentDidMount() {
    const { config } = this.props;
    const { connect } = config.register;

    this.getCodeSponsorship();
    this.setState({
      fields: connect.map((field) => ({
        ...field,
        value: this.props.userInfo[field.name] || "",
        error: "",
      }))
    });
  }

  getCodeSponsorship = () => {
    const { userInfo } = this.props;
    const { code_parrainage } = userInfo;

    if (code_parrainage) {
      this.setState({ sponsorship: code_parrainage });
    }
  };

  _handleChange = (input) => (e) => {
    const value = e.target.value;
    const { fields } = this.state;
    if (input === "emailConfirm"){
      this.setState({ emailConfirm: value });
    } 
    else if (input !== "passwordConfirm") {
      const index = fields.findIndex((el) => el.name === input);
      let newFields = [...fields];
      newFields[index].value = value;
      this.setState({ fields: newFields });
    } else {
      this.setState({ passwordConfirm: value });
    }
  };

  _isEmailValid = () => {
    const { fields, emailConfirm } = this.state;
    const index = fields.findIndex((el) => el.name === "email");

    return (
      !Validate("email", fields[index].value) &&
      fields[index].value?.toLowerCase() === emailConfirm?.toLowerCase()
    );
  };

  _validateEmailConfirm = (isFromEmailField = false) => {
    const { fields, emailConfirm, emailConfirmError } = this.state;
    const { t } = this.props;
    const index = fields.findIndex((el) => el.name === "email");
    if (isFromEmailField && !emailConfirm && !emailConfirmError) {
      this.setState({
        emailConfirmError: "",
      });
    } else if (!this._isEmailValid()) {
      this.setState({
        emailConfirmError: t("error_email_not_same"),
      });
    } else {
      this.setState({
        emailConfirmError: "",
      });
    }
    return fields[index].value?.toLowerCase() === emailConfirm?.toLowerCase();
  };

  /**
   * Valide le champ parrainage
   */
  // _validateSponsorship = () => {
  //   const error = Validate("sponsorship", this.state.sponsorship);
  //   this.setState({
  //     sponsorshipError: error
  //   });
  //   return !error;
  // };

  /**
   * Valide la confirmation du champ password
   */
  _isPasswordValid = () => {
    const { fields, passwordConfirm } = this.state;
    const index = fields.findIndex((el) => el.name === "password");

    return (
      !Validate("password", fields[index].value) &&
      fields[index].value === passwordConfirm
    );
  };

  _validatePasswordConfirm = () => {
    const { fields, passwordConfirm } = this.state;
    const { t } = this.props;
    const index = fields.findIndex((el) => el.name === "password");

    if (!this._isPasswordValid()) {
      this.setState({
        passwordConfirmError: t("error_password_not_same"),
      });
    } else {
      this.setState({
        passwordConfirmError: "",
      });
    }
    return fields[index].value === passwordConfirm;
  };

  _validateField =
    (input) =>
    (displayError = true) => {
      const { fields } = this.state;
      const index = fields.findIndex((el) => el.name === input);
      if (!fields[index].required && fields[index].name !== "phone") {
        return true;
      }
      let error;
      if (fields[index].name === "phone") {
        if (fields[index].value !== "") {
          error = Validate(fields[index].name, fields[index].value);
        }
      } else {
        error =
          Validate("required", fields[index].value) ||
          Validate(fields[index].name, fields[index].value);
      }
      if (displayError) {
        let newFields = [...fields];
        newFields[index].error = error;
        this.setState({
          fields: newFields,
        });
      }
      return !error;
    };

  /**
   * Vailde le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { fields, validConsent } = this.state;
    let validation = fields.every((el) => this._validateField(el.name)(false)) && validConsent;

    // Don't want to spend one more minute on this project so I'm going to do it like this
    if (fields.length > 0) {
      validation = validation && this._isPasswordValid() && this._isEmailValid();
    }

    return validation;
  };

  _onValidate = () => {
    const { onValidate } = this.props;
    const { fields, optins } = this.state;
    let store = {
      opt_ins: {
        custom: {},
      },
      newsletter: this.state.newsletter,
    };
    fields.forEach((el) => {
      store[el.name] = el.value;
    });
    optins.forEach((el) => {
      if (el.id !== "gdpr") {
        if (el.id !== "newsletter") {
          store.opt_ins["custom"][el.id] = el.value;
        } else {
          store.opt_ins[el.id] = el.value;
        }
      }
    });
    const userInfo = store;
    onValidate(userInfo);
  };

  /**
   * CAPTCHA
   */
  verifyCallback = (recaptchaToken) => {
    // Bypass reCAPTCHA for now
    this.setState({ captcha: "bypassed" });
  };

  // RENDER INPUT TEXT FIELDS
  _renderFields = (field) => {
    const { t } = this.props;
    return (
      <div>
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          error={field.error}
          autoComplete="new-password"
        />
      </div>
    );
  };

  _renderEmail= (field) => {
    const { t } = this.props;
    return (
      <>
      <div>
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
            this._validateEmailConfirm(true);
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          error={field.error}
          autoComplete="new-password"
        />
      </div>
      <div>
          <InsInput
            name="emailConfirm"
            type={field.name}
            placeholder={t("email_confirm")}
            onChange={this._handleChange("emailConfirm")}
            onBlur={() => {
              this._validateEmailConfirm();
            }}
            error={this.state.emailConfirmError}
          />
        </div>
      </>
    );
  };

  // RENDER PASSWORD FIELDS
  _renderPassword = (field) => {
    const { t } = this.props;
    return (
      <>
        <div>
          <InsInput
            name={field.name}
            type={field.name}
            placeholder={field.required ? t(field.name) + " *" : t(field.name)}
            onChange={this._handleChange(field.name)}
            onBlur={() => {
              this._validateField(field.name)();
            }}
            error={field.error}
          />
        </div>
        <div>
          <InsInput
            name="passwordConfirm"
            type={field.name}
            placeholder={t("password_confirm")}
            onChange={this._handleChange("passwordConfirm")}
            onBlur={() => {
              this._validatePasswordConfirm();
            }}
            error={this.state.passwordConfirmError}
          />
        </div>
        <div className="step3-validate-password">
          <ValidatePassword value={field.value}>
            {t("help_password")}
          </ValidatePassword>
        </div>
      </>
    );
  };

  render() {
    const { t, config } = this.props;
    const { fields, optins } = this.state;
    const grprLink = config.register?.opt_ins?.ppFilePath || "/";
    // const {
    //   sponsorship,
    //   sponsorshipError
    // } = this.state;
    return (
      <>
        <form
          className="default-container col-flex"
          onSubmit={(e) => e.preventDefault()}
        >
          <StepCount step={3} />
          <p className="bold-label centered mb50">{t("step3")}</p>
          {/* <div className="step3-sponsorship">
            <div className="mb20">
              {t("help_sponsorship")}
              <InsInput
                name="sponsorship"
                type="number"
                onInput={e => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 6);
                }}
                placeholder={t("placeholder")}
                value={sponsorship}
                onChange={this._handleChange("sponsorship")}
                onBlur={this._validateSponsorship}
                error={sponsorshipError}
              />
              <div className="help">{t("not_required")}</div>
            </div>
          </div> */}

          {fields.map((field, index) => {
            switch (field.name) {
              case "password":
                return (
                  <div key={field.name + index}>
                    {this._renderPassword(field)}
                  </div>
                );

              case "birthdate":
                return (
                  <div key={field.name + index}>
                    {this._renderBirthdate(field)}
                  </div>
                );
              
              case "email":
                return (
                  <div key={field.name + index}>
                    {this._renderEmail(field)}
                  </div>
                );

              default:
                return (
                  <div key={field.name + index}>
                    {this._renderFields(field)}
                  </div>
                );
            }
          })}

          <div className="legal-age-mentions mb20 mt20">
            <Trans
              i18nKey="legal_age_mentions"
              defaults="You need to be at least 16 to sign up.<br/><br/>One Retail will use your personal data to manage your account and to give you access to the features available on the platform, for analytics, and where you have opted in, to send you communications.<br/><br/>For more information on how we use your personal data, please see our <link1>Privacy Policy</link1>."
              components={{
                br: <br />,
                link1: <a href={grprLink} target="_blank" rel="noreferrer" />
              }}
              />
          </div>

          <ConnectOptin
              optins={optins}
              updateOptins={(data) => this.setState({optins: data})}
              updateNewsletter={(bool) => this.setState({newsletter: bool})}
              updateValidConsent={(bool) => this.setState({validConsent: bool})}
              required={false}
          />

          <div className="bottom-container">
            {!this._validateFormStep() && (
              <div className="alert_msg mb10">{t("required_only")}</div>
            )}
            
            <InsButton
              text={t("create_account")}
              onClick={this._onValidate}
              disabled={!this._validateFormStep()}
            />
          </div>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(Step3));
